import { render, staticRenderFns } from "./MeasureUserCard.vue?vue&type=template&id=25904148"
import script from "./MeasureUserCard.vue?vue&type=script&lang=ts"
export * from "./MeasureUserCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports